import { useI18n } from '../i18n/I18nContext';
import { LANGUAGES } from '../i18n/translations';

// Compact language toggle, intended for the top-left of the pairing screen.
export function LanguageSwitcher() {
  const { lang, setLang } = useI18n();

  return (
    <div className="lang-switcher">
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          className={`lang-option ${lang === code ? 'active' : ''}`}
          onClick={() => setLang(code)}
          type="button"
        >
          {label}
        </button>
      ))}
    </div>
  );
}
